import {
  FETCH_NAV_ATHLETES_START,
  FETCH_NAV_ATHLETES_FULFILLED,
  FETCH_NAV_ATHLETES_REJECTED,
  FETCH_NAV_ARCHIVED_ATHLETES_START,
  FETCH_NAV_ARCHIVED_ATHLETES_FULFILLED,
  FETCH_NAV_ARCHIVED_ATHLETES_REJECTED,
  FETCH_NAV_ATHLETE_ASSIGNMENTS_START,
  FETCH_NAV_ATHLETE_ASSIGNMENTS_FULFILLED,
  FETCH_NAV_ATHLETE_ASSIGNMENTS_REJECTED,
  FETCH_NAV_ATHLETE_CALENDARS_START,
  FETCH_NAV_ATHLETE_CALENDARS_FULFILLED,
  FETCH_NAV_ATHLETE_CALENDARS_REJECTED,
  FETCH_NAV_ATHLETE_PROGRAMS_START,
  FETCH_NAV_ATHLETE_PROGRAMS_FULFILLED,
  FETCH_NAV_ATHLETE_PROGRAMS_REJECTED,
  FETCH_NAV_CALENDARS_START,
  FETCH_NAV_CALENDARS_FULFILLED,
  FETCH_NAV_CALENDARS_REJECTED,
  FETCH_NAV_CALENDAR_ITEMS_START,
  FETCH_NAV_CALENDAR_ITEMS_FULFILLED,
  FETCH_NAV_CALENDAR_ITEMS_REJECTED,
  FETCH_NAV_CALENDAR_PREVIEW_START,
  FETCH_NAV_CALENDAR_PREVIEW_FULFILLED,
  FETCH_NAV_CALENDAR_PREVIEW_REJECTED,
  FETCH_NAV_GROUPS_START,
  FETCH_NAV_GROUPS_FULFILLED,
  FETCH_NAV_GROUPS_REJECTED,
  FETCH_NAV_PROGRAMS_START,
  FETCH_NAV_PROGRAMS_FULFILLED,
  FETCH_NAV_PROGRAMS_REJECTED,
  FETCH_NAV_PROGRAM_ITEMS_START,
  FETCH_NAV_PROGRAM_ITEMS_FULFILLED,
  FETCH_NAV_PROGRAM_ITEMS_REJECTED,
  FETCH_NAV_PROGRAM_DAY_ONE_START,
  FETCH_NAV_PROGRAM_DAY_ONE_FULFILLED,
  FETCH_NAV_PROGRAM_DAY_ONE_REJECTED,
  FETCH_NAV_PROGRAM_PREVIEW_START,
  FETCH_NAV_PROGRAM_PREVIEW_FULFILLED,
  FETCH_NAV_PROGRAM_PREVIEW_REJECTED,
  FETCH_NAV_USER_START,
  FETCH_NAV_USER_FULFILLED,
  FETCH_NAV_USER_REJECTED,
  UPDATE_NAV_USER_START,
  UPDATE_NAV_USER_FULFILLED,
  UPDATE_NAV_USER_REJECTED,
  UPDATE_NAV_ATHLETE_IMAGE_START,
  UPDATE_NAV_ATHLETE_IMAGE_FULFILLED,
  UPDATE_NAV_ATHLETE_IMAGE_REJECTED,
  REMOVE_NAV_ATHLETE_IMAGE_START,
  REMOVE_NAV_ATHLETE_IMAGE_FULFILLED,
  REMOVE_NAV_ATHLETE_IMAGE_REJECTED,
  DELETE_NAV_USERS_START,
  DELETE_NAV_USERS_FULFILLED,
  DELETE_NAV_USERS_REJECTED,
  FETCH_NAV_WORKOUT_RESULTS_START,
  FETCH_NAV_WORKOUT_RESULTS_FULFILLED,
  FETCH_NAV_WORKOUT_RESULTS_REJECTED,
  FETCH_NAV_DAY_WORKOUT_ITEMS_START,
  FETCH_NAV_DAY_WORKOUT_ITEMS_FULFILLED,
  FETCH_NAV_DAY_WORKOUT_ITEMS_REJECTED,
} from './actionTypes';

const initialState = {
  athletes: [],
  athletesError: null,
  archivedAthletes: [],
  archivedAthletesError: null,
  athleteCalendars: [],
  athleteCalendarsError: null,
  athletePrograms: [],
  athleteProgramsError: null,
  athleteImage: null,
  athleteImageError: null,
  activeCalendars: [],
  activePrograms: [],
  inactiveCalendars: [],
  calendars: [],
  calendarsError: null,
  calendarPreview: [],
  calendarPreviewError: null,
  calendarItems: null,
  calendarItemsError: null,
  calendarWorkoutDate: null,
  currentWorkout: { workoutItems: [] },
  dayWorkoutItemsError: null,
  groups: [],
  groupsError: null,
  programs: [],
  programsError: null,
  programItems: null,
  programItemsError: null,
  programPreviewItems: null,
  programPreviewDays: [],
  programPreviewInitialDayIndex: 0,
  programPreviewWeekNumber: null,
  programPreviewDayInWeek: null,
  programPreviewError: null,
  programDayOneError: null,
  deleteNavUsersError: null,
  selectedUser: null,
  selectedUserError: null,
  selectedUserAssignments: null,
  selectedUserAssignmentsError: null,
  workoutResults: null,
  workoutResultsError: null,
};

// eslint-disable-next-line default-param-last
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_NAV_ATHLETES_START:
      return {
        ...state,
        athletesError: null,
      };
    case FETCH_NAV_ATHLETES_FULFILLED:
      return {
        ...state,
        athletes: action.payload,
        athletesError: null,
      };
    case FETCH_NAV_ATHLETES_REJECTED:
      return {
        ...state,
        athletesError: action.payload,
      };
    case FETCH_NAV_ARCHIVED_ATHLETES_START:
      return {
        ...state,
        archivedAthletes: [],
        archivedAthletesError: null,
      };
    case FETCH_NAV_ARCHIVED_ATHLETES_FULFILLED:
      return {
        ...state,
        archivedAthletes: action.payload,
        archivedAthletesError: null,
      };
    case FETCH_NAV_ARCHIVED_ATHLETES_REJECTED:
      return {
        ...state,
        archivedAthletesError: action.payload,
      };
    case FETCH_NAV_ATHLETE_ASSIGNMENTS_START:
      return {
        ...state,
        selectedUserAssignmentsError: null,
      };
    case FETCH_NAV_ATHLETE_ASSIGNMENTS_FULFILLED:
      return {
        ...state,
        selectedUserAssignments: action.payload,
        selectedUserAssignmentsError: null,
      };
    case FETCH_NAV_ATHLETE_ASSIGNMENTS_REJECTED:
      return {
        ...state,
        selectedUserAssignmentsError: action.payload,
      };
    case FETCH_NAV_ATHLETE_CALENDARS_START:
      return {
        ...state,
        athleteCalendars: [],
        athleteCalendarsError: null,
      };
    case FETCH_NAV_ATHLETE_CALENDARS_FULFILLED:
      return {
        ...state,
        athleteCalendars: action.payload || [],
        athleteCalendarsError: null,
      };
    case FETCH_NAV_ATHLETE_CALENDARS_REJECTED:
      return {
        ...state,
        athleteCalendarsError: action.payload,
      };
    case FETCH_NAV_ATHLETE_PROGRAMS_START:
      return {
        ...state,
        athletePrograms: [],
        athleteProgramsError: null,
      };
    case FETCH_NAV_ATHLETE_PROGRAMS_FULFILLED:
      return {
        ...state,
        athletePrograms: action.payload || [],
        athleteProgramsError: null,
      };
    case FETCH_NAV_ATHLETE_PROGRAMS_REJECTED:
      return {
        ...state,
        athleteProgramsError: action.payload,
      };
    case FETCH_NAV_CALENDARS_START:
      return {
        ...state,
        calendarsError: null,
      };
    case FETCH_NAV_CALENDARS_FULFILLED:
    {
      const activeCalendars = action.payload.activeCalendars || [];
      const inactiveCalendars = action.payload.inactiveCalendars || [];
      const calendars = [...activeCalendars, ...inactiveCalendars]
        .sort((a, b) => a.name.localeCompare(b.name));

      return {
        ...state,
        activeCalendars,
        inactiveCalendars,
        calendars,
        calendarsError: null,
      };
    }
    case FETCH_NAV_CALENDARS_REJECTED:
      return {
        ...state,
        calendarsError: action.payload,
      };
    case FETCH_NAV_CALENDAR_ITEMS_START:
      return {
        ...state,
        calendarItems: null,
        calendarWorkoutDate: null,
        calendarItemsError: null,
      };
    case FETCH_NAV_CALENDAR_ITEMS_FULFILLED:
      return {
        ...state,
        calendarItems: action.payload.workoutItems,
        calendarWorkoutDate: action.payload.workoutDate,
        calendarItemsError: null,
      };
    case FETCH_NAV_CALENDAR_ITEMS_REJECTED:
      return {
        ...state,
        calendarItemsError: action.payload,
      };
    case FETCH_NAV_CALENDAR_PREVIEW_START:
      return {
        ...state,
        calendarPreview: [],
        calendarPreviewError: null,
      };
    case FETCH_NAV_CALENDAR_PREVIEW_FULFILLED: {
      return {
        ...state,
        calendarPreview: action.payload || [],
        calendarPreviewError: null,
      };
    }
    case FETCH_NAV_CALENDAR_PREVIEW_REJECTED: {
      return {
        ...state,
        calendarPreview: [],
        calendarPreviewError: action.payload,
      };
    }
    case FETCH_NAV_GROUPS_START:
      return {
        ...state,
        groups: [],
        groupsError: null,
      };
    case FETCH_NAV_GROUPS_FULFILLED:
      return {
        ...state,
        groups: action.payload,
        groupsError: null,
      };
    case FETCH_NAV_GROUPS_REJECTED:
      return {
        ...state,
        groups: [],
        groupsError: action.payload,
      };
    case FETCH_NAV_PROGRAMS_START:
      return {
        ...state,
        programsError: null,
      };
    case FETCH_NAV_PROGRAMS_FULFILLED:
      return {
        ...state,
        programs: action.payload || [],
        programsError: null,
      };
    case FETCH_NAV_PROGRAMS_REJECTED:
      return {
        ...state,
        programsError: action.payload,
      };
    case FETCH_NAV_PROGRAM_ITEMS_START:
      return {
        ...state,
        programItemsError: null,
      };
    case FETCH_NAV_PROGRAM_ITEMS_FULFILLED:
      return {
        ...state,
        programItems: action.payload,
        programItemsError: null,
      };
    case FETCH_NAV_PROGRAM_ITEMS_REJECTED:
      return {
        ...state,
        programItemsError: action.payload,
      };
    case FETCH_NAV_PROGRAM_DAY_ONE_START:
      return {
        ...state,
        activePrograms: [],
        currentWorkout: { workoutItems: [] },
        programDayOneError: null,
      };
    case FETCH_NAV_PROGRAM_DAY_ONE_FULFILLED: {
      const data = action.payload?.data || {};
      const program = action.payload?.program || null;
      return {
        ...state,
        activePrograms: action.payload.data || [],
        currentWorkout: {
          ...data,
          assignedDayBasedProgramsData: program
            ? [program]
            : (data.assignedDayBasedProgramsData
              ?? state.currentWorkout.assignedDayBasedProgramsData ?? []),
        },
        programDayOneError: null,
      };
    }
    case FETCH_NAV_PROGRAM_DAY_ONE_REJECTED: {
      return {
        ...state,
        activePrograms: [],
        currentWorkout: { workoutItems: [] },
        programDayOneError: action.payload,
      };
    }
    case FETCH_NAV_PROGRAM_PREVIEW_START:
      return {
        ...state,
        programPreviewItems: null,
        programPreviewDays: [],
        programPreviewInitialDayIndex: 0,
        programPreviewWeekNumber: null,
        programPreviewDayInWeek: null,
        programPreviewError: null,
      };
    case FETCH_NAV_PROGRAM_PREVIEW_FULFILLED:
      return {
        ...state,
        programPreviewItems:
          action.payload.programDays?.[action.payload.initialDayIndex]?.exercises || [],
        programPreviewDays: action.payload.programDays || [],
        programPreviewInitialDayIndex: action.payload.initialDayIndex || 0,
        programPreviewWeekNumber: null,
        programPreviewDayInWeek: null,
        programPreviewError: null,
      };
    case FETCH_NAV_PROGRAM_PREVIEW_REJECTED:
      return {
        ...state,
        programPreviewError: action.payload,
      };
    case FETCH_NAV_USER_START:
      return {
        ...state,
        selectedUser: null,
        selectedUserError: null,
      };
    case FETCH_NAV_USER_FULFILLED:
      return {
        ...state,
        selectedUser: action.payload,
        selectedUserError: null,
      };
    case FETCH_NAV_USER_REJECTED:
      return {
        ...state,
        selectedUser: null,
        selectedUserError: action.payload,
      };
    case UPDATE_NAV_USER_START:
      return {
        ...state,
        selectedUserError: null,
      };
    case UPDATE_NAV_USER_FULFILLED:
      return {
        ...state,
        selectedUser: action.payload,
        selectedUserError: null,
        athletes: state.athletes.map((a) => (
          a.id === action.payload.id ? { ...a, ...action.payload } : a
        )),
      };
    case UPDATE_NAV_USER_REJECTED:
      return {
        ...state,
        selectedUserError: action.payload,
      };
    case UPDATE_NAV_ATHLETE_IMAGE_START:
      return {
        ...state,
        athleteImage: null,
        athleteImageError: null,
      };
    case UPDATE_NAV_ATHLETE_IMAGE_FULFILLED:
      return {
        ...state,
        athleteImage: action.payload,
        athleteImageError: null,
        selectedUser: action.payload,
        athletes: state.athletes.map((a) => (
          a.id === action.payload.id ? { ...a, ...action.payload } : a
        )),
      };
    case UPDATE_NAV_ATHLETE_IMAGE_REJECTED:
      return {
        ...state,
        athleteImage: null,
        athleteImageError: action.payload,
      };
    case REMOVE_NAV_ATHLETE_IMAGE_START:
      return {
        ...state,
        athleteImage: null,
        athleteImageError: null,
      };
    case REMOVE_NAV_ATHLETE_IMAGE_FULFILLED:
      return {
        ...state,
        athleteImage: action.payload,
        athleteImageError: null,
        selectedUser: action.payload,
        athletes: state.athletes.map((a) => (
          a.id === action.payload.id ? { ...a, ...action.payload } : a
        )),
      };
    case REMOVE_NAV_ATHLETE_IMAGE_REJECTED:
      return {
        ...state,
        athleteImage: null,
        athleteImageError: action.payload,
      };
    case FETCH_NAV_WORKOUT_RESULTS_START:
      return {
        ...state,
        workoutResultsError: null,
      };
    case FETCH_NAV_WORKOUT_RESULTS_FULFILLED:
      return {
        ...state,
        workoutResults: action.payload,
        workoutResultsError: null,
      };
    case FETCH_NAV_WORKOUT_RESULTS_REJECTED:
      return {
        ...state,
        workoutResultsError: action.payload,
      };
    case FETCH_NAV_DAY_WORKOUT_ITEMS_START:
      return {
        ...state,
        currentWorkout: { workoutItems: [] },
        dayWorkoutItemsError: null,
      };
    case FETCH_NAV_DAY_WORKOUT_ITEMS_FULFILLED: {
      return {
        ...state,
        currentWorkout: action.payload.data,
        dayWorkoutItemsError: null,
      };
    }
    case FETCH_NAV_DAY_WORKOUT_ITEMS_REJECTED: {
      return {
        ...state,
        currentWorkout: { workoutItems: [] },
        dayWorkoutItemsError: action.payload,
      };
    }
    case DELETE_NAV_USERS_START:
      return {
        ...state,
        deleteNavUsersError: null,
      };
    case DELETE_NAV_USERS_FULFILLED:
      return {
        ...state,
        athletes: state.athletes.filter((a) => !action.payload.includes(a.id)),
        archivedAthletes: state.archivedAthletes.filter((a) => !action.payload.includes(a.id)),
        deleteNavUsersError: null,
      };
    case DELETE_NAV_USERS_REJECTED:
      return {
        ...state,
        deleteNavUsersError: action.payload,
      };
    default:
      return state;
  }
}
